import { render, staticRenderFns } from "./InvoiceUpdateRemarkWindow.vue?vue&type=template&id=03a78b6f&scoped=true&"
import script from "./InvoiceUpdateRemarkWindow.vue?vue&type=script&lang=js&"
export * from "./InvoiceUpdateRemarkWindow.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceUpdateRemarkWindow.vue?vue&type=style&index=0&id=03a78b6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a78b6f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03a78b6f')) {
      api.createRecord('03a78b6f', component.options)
    } else {
      api.reload('03a78b6f', component.options)
    }
    module.hot.accept("./InvoiceUpdateRemarkWindow.vue?vue&type=template&id=03a78b6f&scoped=true&", function () {
      api.rerender('03a78b6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/makeInvoice/InvoiceUpdateRemarkWindow.vue"
export default component.exports